// import { useLabelListQuery } from 'src/app/label/hooks';
import { useRepplEpisodesQuery, useRepplQuery } from 'src/app/reppl/hooks';
import { useContext, useEffect } from 'react';
import { UserContext, UserContextType } from 'src/contexts/UserContext';
import { useLocalStorage } from 'src/hooks';
import { AboutReppl } from './about-reppl';
import { CreatorPick } from './creator-pick';
import FeatureCollection from './feature-collection';
import RecentEpisodes from './recent-episodes';
import { FeatureEpisodes } from './feature-episodes';

export function FrontPage({ rid }) {
  const { user } = useContext(UserContext) as UserContextType;
  const { data: repplData, isFetched, isFetchedAfterMount } = useRepplQuery(
    rid
  );
  const creator = repplData?.creator;
  const reppl = repplData?.reppl;
  const { data: episodes } = useRepplEpisodesQuery({
    repplId: reppl?.id,
    params: {
      sortType: 'RECENCY',
      pageSize: 8,
    },
  });
  const { data: episodesMostEnthused } = useRepplEpisodesQuery({
    repplId: reppl?.id,
    params: {
      sortType: 'MOST_LIKE',
      pageSize: 8,
    },
  });

  const { data: featuredEpis } = useRepplEpisodesQuery({
    repplId: reppl?.id,
    params: {
      trait: 'PICK',
      pageSize: 32,
    },
  });
  // isLoading: pinIsLoading
  const { data: pinEpisodes } = useRepplEpisodesQuery({
    repplId: reppl?.id,
    params: {
      trait: 'PIN',
      pageSize: 8,
    },
  });

  const isOwner = user && user.username === creator?.username;
  const creatorPin = pinEpisodes?.pages?.flatMap((ep) => ep.data) ?? [];
  const episodeList = episodes?.pages?.flatMap((ep) => ep.data) ?? [];
  const episodeListMostEnthused =
    episodesMostEnthused?.pages?.flatMap((ep) => ep.data) ?? [];
  const featuredList = featuredEpis?.pages.flatMap((ep) => ep.data) ?? [];
  const officialFeatured =
    featuredList.filter((ep) => ep.official && ep.pick) ?? [];
  const openFeatured =
    featuredList.filter((ep) => !ep.official && ep.pick) ?? [];

  const [recentLocal, setRecentLocal] = useLocalStorage('recentReppls', []);

  const date = new Date();

  useEffect(() => {
    const repplSessions = recentLocal;
    if (reppl) {
      const isSaved = repplSessions
        .map((e) => {
          return e.id;
        })
        .indexOf(reppl.id);
      if (isSaved < 0) {
        repplSessions.push({
          title: reppl.title,
          id: reppl.id,
          href: `/reppl/${reppl.id}`,
          avatar: reppl.avatarImgURL,
          about: reppl.summary,
          lastVisit: date,
        });
      }
    }
    if (repplSessions.length > 5) {
      repplSessions.shift();
    }
    setRecentLocal(recentLocal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reppl]);

  const featuredCollection = reppl?.feature.filter(({ visible }) => visible);
  return (
    <div>
      <CreatorPick
        isOwner={isOwner}
        isLoaded={isFetchedAfterMount}
        data={creatorPin}
      />
      <div className="mb-16">
        <RecentEpisodes
          isOwner={isOwner}
          reppl={reppl}
          episodes={episodeList}
          episodesMostEnthused={episodeListMostEnthused}
          isLoaded={isFetched}
        />
      </div>
      <AboutReppl isLoaded={isFetched} isOwner={isOwner} {...repplData} />
      <FeatureEpisodes
        reppl={reppl}
        // episodes={episodeList.slice(0, 5)}
        episodes={officialFeatured}
        isLoaded={isFetched}
        type="official"
        isOwner={isOwner}
      />
      <FeatureEpisodes
        reppl={reppl}
        // episodes={episodeList}
        episodes={openFeatured}
        isLoaded={isFetched}
        type="open"
        isOwner={isOwner}
      />
      <FeatureCollection
        rid={rid}
        isLoaded={isFetched}
        isOwner={isOwner}
        collections={featuredCollection}
        reppl={reppl}
      />
    </div>
  );
}
